// Gedeeld account (SPEC 27okt 1): wie werkt er achter calculaties@? De naam geldt voor deze sessie en
// komt bij elke logregel naast het account. Overslaan mag; dan vragen we het niet opnieuw in deze
// sessie (sessionStorage: enkel een gemak per tabblad, de server bewaart de persoon zelf).
import { useEffect, useRef, useState } from 'react';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';

const OVERGESLAGEN = 'recotex.persoon.overgeslagen';
const LAATSTE = 'recotex.persoon.laatste';
const VASTE_SUGGESTIES = ['Eranda'];

function lees(opslag: 'session' | 'local', sleutel: string): string | null {
  try {
    return (opslag === 'session' ? window.sessionStorage : window.localStorage).getItem(sleutel);
  } catch {
    return null;
  }
}
function schrijf(opslag: 'session' | 'local', sleutel: string, waarde: string): void {
  try {
    (opslag === 'session' ? window.sessionStorage : window.localStorage).setItem(sleutel, waarde);
  } catch {
    /* privévenster of geblokkeerde opslag: dan vragen we het gewoon opnieuw */
  }
}

/** Moet de vraag vanzelf verschijnen? Gedeeld account, nog geen persoon, niet overgeslagen. */
export function moetPersoonVragen(user: { gedeeldAccount?: boolean; persoon?: string | null } | null): boolean {
  return !!user?.gedeeldAccount && !user.persoon && lees('session', OVERGESLAGEN) !== '1';
}

export function GedeeldAccountVraag({ onSluit }: { onSluit: () => void }) {
  const { user, refresh } = useAuth();
  const [naam, setNaam] = useState(user?.persoon ?? '');
  const [bezig, setBezig] = useState(false);
  const [fout, setFout] = useState('');
  const invoer = useRef<HTMLInputElement>(null);
  const laatste = lees('local', LAATSTE);
  const suggesties = [...new Set([...(laatste ? [laatste] : []), ...VASTE_SUGGESTIES])];
  const account = (user?.email ?? '').split('@')[0] + '@';

  useEffect(() => { invoer.current?.focus(); }, []);

  const overslaan = () => {
    schrijf('session', OVERGESLAGEN, '1');
    onSluit();
  };
  const bevestig = async () => {
    const n = naam.trim();
    if (n.length < 2 || bezig) return;
    setBezig(true);
    setFout('');
    try {
      await api.auth.zetPersoon(n);
      schrijf('local', LAATSTE, n);
      await refresh();
      onSluit();
    } catch {
      setFout('Opslaan mislukt. Probeer opnieuw of sla over.');
    } finally {
      setBezig(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-primary-800/40 p-4" onKeyDown={(e) => { if (e.key === 'Escape') overslaan(); }}>
      <div role="dialog" aria-modal="true" aria-labelledby="persoon-titel" aria-describedby="persoon-uitleg"
        className="w-full max-w-md rounded-lg border border-border bg-white p-6 shadow-lg text-primary normal-case tracking-normal">
        <h2 id="persoon-titel" className="text-lg font-bold mb-2">Wie werkt er?</h2>
        <p id="persoon-uitleg" className="text-sm mb-4">
          Je werkt met het gedeelde account <strong>{account}</strong>. Wie werkt er? Je naam komt in de log bij elke wijziging, naast het account.
        </p>
        <form onSubmit={(e) => { e.preventDefault(); void bevestig(); }}>
          <label htmlFor="persoon-naam" className="field-label">Naam</label>
          <input id="persoon-naam" ref={invoer} className="input" maxLength={100} autoComplete="given-name"
            value={naam} onChange={(e) => setNaam(e.target.value)} placeholder="Voornaam" />
          {suggesties.length > 0 && (
            <div className="flex flex-wrap items-center gap-2 mt-2">
              <span className="text-xs text-secondary">Suggestie:</span>
              {suggesties.map((s) => (
                <button key={s} type="button" onClick={() => setNaam(s)} aria-pressed={naam.trim() === s}
                  className={`rounded-full border px-3 py-1 text-xs font-bold transition-colors ${naam.trim() === s ? 'border-primary bg-primary text-white' : 'border-border bg-white text-primary hover:border-primary'}`}>
                  {s}
                </button>
              ))}
            </div>
          )}
          {fout && <p className="text-xs text-danger mt-2" role="alert">{fout}</p>}
          <div className="flex justify-end gap-2 mt-5">
            <button type="button" className="btn-ghost btn-sm" onClick={overslaan}>Overslaan</button>
            <button type="submit" className="btn-primary btn-sm" disabled={naam.trim().length < 2 || bezig}>
              {bezig ? 'Opslaan…' : 'Bevestigen'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
